// @flow
import React from 'react';

const NewIcon = () => (
  <img className="newIcon" src={`${process.env.IMAGES_URL}/new-icon.svg`} alt="newIcon" />
);

export default NewIcon;



// WEBPACK FOOTER //
// ./src/components/common/Icons/NewIcon/NewIcon.js